var ze = Object.defineProperty, Me = Object.defineProperties;
var Be = Object.getOwnPropertyDescriptors;
var B = Object.getOwnPropertySymbols;
var ge = Object.prototype.hasOwnProperty, ue = Object.prototype.propertyIsEnumerable;
var q = (n, e, t) => e in n ? ze(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, w = (n, e) => {
  for (var t in e || (e = {}))
    ge.call(e, t) && q(n, t, e[t]);
  if (B)
    for (var t of B(e))
      ue.call(e, t) && q(n, t, e[t]);
  return n;
}, y = (n, e) => Me(n, Be(e));
var K = (n, e) => {
  var t = {};
  for (var s in n)
    ge.call(n, s) && e.indexOf(s) < 0 && (t[s] = n[s]);
  if (n != null && B)
    for (var s of B(n))
      e.indexOf(s) < 0 && ue.call(n, s) && (t[s] = n[s]);
  return t;
};
var a = (n, e, t) => q(n, typeof e != "symbol" ? e + "" : e, t);
var R = (n, e, t) => new Promise((s, i) => {
  var o = (d) => {
    try {
      c(t.next(d));
    } catch (l) {
      i(l);
    }
  }, r = (d) => {
    try {
      c(t.throw(d));
    } catch (l) {
      i(l);
    }
  }, c = (d) => d.done ? s(d.value) : Promise.resolve(d.value).then(o, r);
  c((t = t.apply(n, e)).next());
});
import { W as Fe, M as C, r as j, I as me, a as fe, S as Ve, P as $e, C as Ae, F as xe, b as qe, c as Ke, d as pe, g as je, e as Ge, f as Je, h as Qe, i as Ye, s as Xe, j as Ze } from "./record-C-1UPGV3.js";
import { R as Gt } from "./record-C-1UPGV3.js";
import { A as et, s as $, G as A, g as M, S as L, r as we, a as G, b as tt, c as st, d as J, e as Q, f as P, F as Se, M as _, h as E, V as it, i as nt, H as Y, j as rt, k as ot, L as Le, l as Ee, p as at, m as ye, n as be, o as ct, q as lt, t as dt, u as ht, P as gt, v as ut, w as mt } from "./common-BzocrL51.js";
import { X as ft, F as pt, C as wt, E as St, s as yt, D as bt, a as kt, m as ke, d as Ne, b as ve, c as Re, e as vt, p as Rt, f as Dt, g as _t, h as It, W as Ct, N as Lt, P as Et, J as Nt, i as F, B as V, j as Ot, k as De, l as _e } from "./observe-D7ON5TW2.js";
import { O as Qt } from "./observe-D7ON5TW2.js";
import { L as Tt } from "./buffer-BNTl5fQI.js";
import { LDObserve as Xt } from "./LDObserve.js";
import { LDRecord as es } from "./LDRecord.js";
const Ht = (n, e, t) => {
  const s = window._highlightWebSocketRequestCallback;
  window._highlightWebSocketRequestCallback = n;
  const i = window._highlightWebSocketEventCallback;
  return window._highlightWebSocketEventCallback = (o) => {
    const u = o, { message: r, size: c } = u, d = K(u, ["message", "size"]), h = t.some(
      (m) => o.name.toLowerCase().includes(m)
    ) ? d : o;
    e(h);
  }, () => {
    window._highlightWebSocketRequestCallback = s, window._highlightWebSocketEventCallback = i;
  };
}, Pt = ({
  xhrCallback: n,
  fetchCallback: e,
  webSocketRequestCallback: t,
  webSocketEventCallback: s,
  disableWebSocketRecording: i,
  bodyKeysToRedact: o,
  highlightEndpoints: r,
  tracingOrigins: c,
  urlBlocklist: d,
  bodyKeysToRecord: l
}) => {
  const h = ft(
    n,
    r,
    c,
    d,
    o,
    l
  ), u = pt(
    e,
    r,
    c,
    d,
    o,
    l
  ), m = i ? () => {
  } : Ht(
    t,
    s,
    d
  );
  return () => {
    h(), u(), m();
  };
};
class I {
  constructor(e) {
    a(this, "disableConsoleRecording");
    a(this, "reportConsoleErrors");
    a(this, "enablePromisePatch");
    a(this, "consoleMethodsToRecord");
    a(this, "listeners");
    a(this, "errors");
    a(this, "messages");
    // The properties below were added in 4.0.0 (Feb 2022), and are patched in by client via setupNetworkListeners()
    a(this, "options");
    a(this, "hasNetworkRecording", !0);
    a(this, "disableNetworkRecording");
    a(this, "enableRecordingNetworkContents");
    a(this, "xhrNetworkContents");
    a(this, "fetchNetworkContents");
    a(this, "disableRecordingWebSocketContents");
    a(this, "webSocketNetworkContents");
    a(this, "webSocketEventContents");
    a(this, "tracingOrigins");
    a(this, "networkHeadersToRedact");
    a(this, "networkBodyKeysToRedact");
    a(this, "networkBodyKeysToRecord");
    a(this, "networkHeaderKeysToRecord");
    a(this, "lastNetworkRequestTimestamp");
    a(this, "urlBlocklist");
    a(this, "highlightEndpoints");
    a(this, "requestResponseSanitizer");
    var t, s;
    this.options = e, this.disableConsoleRecording = !!e.disableConsoleRecording, this.reportConsoleErrors = (t = e.reportConsoleErrors) != null ? t : !1, this.enablePromisePatch = (s = e.enablePromisePatch) != null ? s : !1, this.consoleMethodsToRecord = e.consoleMethodsToRecord || [
      ...et
    ], this.listeners = [], this.errors = [], this.messages = [], this.lastNetworkRequestTimestamp = 0;
  }
  isListening() {
    return this.listeners.length > 0;
  }
  startListening() {
    if (this.isListening()) return;
    const e = this;
    this.disableConsoleRecording || this.listeners.push(
      wt(
        (t) => {
          var s, i, o;
          if (this.reportConsoleErrors && (t.type === "Error" || t.type === "error") && t.value && t.trace) {
            const r = $(t.value);
            if (ve.includes(r) || Re.some(
              (c) => r.includes(c)
            ))
              return;
            e.errors.push({
              event: r,
              type: "console.error",
              url: window.location.href,
              source: (s = t.trace[0]) != null && s.fileName ? t.trace[0].fileName : "",
              lineNumber: (i = t.trace[0]) != null && i.lineNumber ? t.trace[0].lineNumber : 0,
              columnNumber: (o = t.trace[0]) != null && o.columnNumber ? t.trace[0].columnNumber : 0,
              stackTrace: t.trace,
              timestamp: (/* @__PURE__ */ new Date()).toISOString()
            });
          }
          e.messages.push(t);
        },
        y(w({}, Ne), {
          level: this.consoleMethodsToRecord
        })
      )
    ), this.listeners.push(
      St(
        (t) => {
          ve.includes(t.event) || Re.some(
            (s) => t.event.includes(s)
          ) || e.errors.push(t);
        },
        { enablePromisePatch: this.enablePromisePatch }
      )
    ), this.listeners.push(yt), I.setupNetworkListener(this, this.options);
  }
  stopListening() {
    this.listeners.forEach((e) => e()), this.listeners = [];
  }
  // We define this as a static method because versions earlier than 4.0.0 (Feb 2022) don't have this code.
  // For those versions, calling this from client will monkey-patch the network listeners onto the old FirstLoadListener object.
  static setupNetworkListener(e, t) {
    var o, r, c, d, l, h, u, m, f, D, k, N;
    const s = (t == null ? void 0 : t.backendUrl) || void 0 || "https://pub.highlight.io", i = t.otlpEndpoint || "https://otel.highlight.io";
    e.highlightEndpoints = [
      s,
      `${i}/v1/traces`,
      `${i}/v1/logs`,
      `${i}/v1/metrics`
    ], e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.webSocketNetworkContents = [], e.webSocketEventContents = [], e.networkHeadersToRedact = [], e.urlBlocklist = [], e.tracingOrigins = t.tracingOrigins || [], (t == null ? void 0 : t.disableNetworkRecording) !== void 0 ? (e.disableNetworkRecording = t == null ? void 0 : t.disableNetworkRecording, e.enableRecordingNetworkContents = !1, e.disableRecordingWebSocketContents = !0, e.networkHeadersToRedact = [], e.networkBodyKeysToRedact = [], e.urlBlocklist = [], e.networkBodyKeysToRecord = []) : typeof (t == null ? void 0 : t.networkRecording) == "boolean" ? (e.disableNetworkRecording = !t.networkRecording, e.enableRecordingNetworkContents = !1, e.disableRecordingWebSocketContents = !0, e.networkHeadersToRedact = [], e.networkBodyKeysToRedact = [], e.urlBlocklist = []) : (((o = t.networkRecording) == null ? void 0 : o.enabled) !== void 0 ? e.disableNetworkRecording = !t.networkRecording.enabled : e.disableNetworkRecording = !1, e.enableRecordingNetworkContents = ((r = t.networkRecording) == null ? void 0 : r.recordHeadersAndBody) || !1, e.disableRecordingWebSocketContents = ((c = t.networkRecording) == null ? void 0 : c.disableWebSocketEventRecordings) || !1, e.networkHeadersToRedact = ((l = (d = t.networkRecording) == null ? void 0 : d.networkHeadersToRedact) == null ? void 0 : l.map(
      (S) => S.toLowerCase()
    )) || [], e.networkBodyKeysToRedact = ((u = (h = t.networkRecording) == null ? void 0 : h.networkBodyKeysToRedact) == null ? void 0 : u.map(
      (S) => S.toLowerCase()
    )) || [], e.urlBlocklist = ((f = (m = t.networkRecording) == null ? void 0 : m.urlBlocklist) == null ? void 0 : f.map(
      (S) => S.toLowerCase()
    )) || [], e.urlBlocklist = [
      ...e.urlBlocklist,
      ...bt
    ], e.requestResponseSanitizer = (D = t.networkRecording) == null ? void 0 : D.requestResponseSanitizer, e.networkHeaderKeysToRecord = (k = t.networkRecording) == null ? void 0 : k.headerKeysToRecord, e.networkHeaderKeysToRecord && (e.networkHeadersToRedact = [], e.networkHeaderKeysToRecord = e.networkHeaderKeysToRecord.map(
      (S) => S.toLocaleLowerCase()
    )), e.networkBodyKeysToRecord = (N = t.networkRecording) == null ? void 0 : N.bodyKeysToRecord, e.networkBodyKeysToRecord && (e.networkBodyKeysToRedact = [], e.networkBodyKeysToRecord = e.networkBodyKeysToRecord.map(
      (S) => S.toLocaleLowerCase()
    ))), !e.disableNetworkRecording && e.enableRecordingNetworkContents && e.listeners.push(
      Pt({
        xhrCallback: (S) => {
          e.xhrNetworkContents.push(S);
        },
        fetchCallback: (S) => {
          e.fetchNetworkContents.push(S);
        },
        webSocketRequestCallback: (S) => {
          e.webSocketNetworkContents && e.webSocketNetworkContents.push(S);
        },
        webSocketEventCallback: (S) => {
          e.webSocketEventContents.push(S);
        },
        disableWebSocketRecording: e.disableRecordingWebSocketContents,
        bodyKeysToRedact: e.networkBodyKeysToRedact,
        highlightEndpoints: e.highlightEndpoints,
        tracingOrigins: e.tracingOrigins,
        urlBlocklist: e.urlBlocklist,
        bodyKeysToRecord: e.networkBodyKeysToRecord
      })
    );
  }
  static getRecordedNetworkResources(e, t) {
    var o, r;
    let s = [], i = [];
    if (!e.disableNetworkRecording) {
      const c = ((o = window == null ? void 0 : window.performance) == null ? void 0 : o.timeOrigin) || 0;
      s = performance.getEntriesByType(
        "resource"
      );
      const d = (t - c) * 2;
      if (s = s.filter((l) => l.responseEnd < e.lastNetworkRequestTimestamp ? !1 : kt(
        l.name,
        e.highlightEndpoints
      )).map((l) => y(w({}, l.toJSON()), {
        offsetStartTime: l.startTime - d,
        offsetResponseEnd: l.responseEnd - d,
        offsetFetchStart: l.fetchStart - d
      })), e.lastNetworkRequestTimestamp = ((r = s.at(-1)) == null ? void 0 : r.responseEnd) || e.lastNetworkRequestTimestamp, e.enableRecordingNetworkContents) {
        const l = {
          headersToRedact: e.networkHeadersToRedact,
          headersToRecord: e.networkHeaderKeysToRecord,
          requestResponseSanitizer: e.requestResponseSanitizer
        };
        s = ke(
          s,
          e.xhrNetworkContents,
          "xmlhttprequest",
          l
        ), s = ke(
          s,
          e.fetchNetworkContents,
          "fetch",
          l
        );
      }
    }
    return e.disableRecordingWebSocketContents || (i = e.webSocketNetworkContents || []), [...s, ...i];
  }
  static getRecordedWebSocketEvents(e) {
    let t = [];
    return !e.disableNetworkRecording && !e.disableRecordingWebSocketContents && (t = e.webSocketEventContents), t;
  }
  static clearRecordedNetworkResources(e) {
    e.disableNetworkRecording || (e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.webSocketNetworkContents = [], e.webSocketEventContents = [], performance.clearResourceTimings());
  }
}
const U = (n, e) => {
  console.warn(`Highlight Warning: (${n}): `, { output: e });
};
class Z {
  constructor(e, t) {
    a(this, "options");
    /** Determines if the client is running on a Highlight property (e.g. frontend). */
    a(this, "isRunningOnHighlight");
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    a(this, "organizationID");
    a(this, "graphqlSDK");
    a(this, "events");
    a(this, "sessionData");
    a(this, "ready");
    a(this, "manualStopped");
    a(this, "state");
    a(this, "logger");
    a(this, "enableSegmentIntegration");
    a(this, "privacySetting");
    a(this, "enableCanvasRecording");
    a(this, "enablePerformanceRecording");
    a(this, "samplingStrategy");
    a(this, "inlineImages");
    a(this, "inlineVideos");
    a(this, "inlineStylesheet");
    a(this, "debugOptions");
    a(this, "listeners");
    a(this, "firstloadVersion");
    a(this, "environment");
    a(this, "sessionShortcut");
    /** The end-user's app version. This isn't Highlight's version. */
    a(this, "appVersion");
    a(this, "serviceName");
    a(this, "_worker");
    a(this, "_optionsInternal");
    a(this, "_backendUrl");
    a(this, "_recordingStartTime");
    a(this, "_isOnLocalHost");
    a(this, "_onToggleFeedbackFormVisibility");
    a(this, "_firstLoadListeners");
    a(this, "_isCrossOriginIframe");
    a(this, "_eventBytesSinceSnapshot");
    a(this, "_lastSnapshotTime");
    a(this, "_lastVisibilityChangeTime");
    a(this, "pushPayloadTimerId");
    a(this, "hasSessionUnloaded");
    a(this, "hasPushedData");
    a(this, "reloaded");
    a(this, "_hasPreviouslyInitialized");
    a(this, "_recordStop");
    a(this, "_gauges", /* @__PURE__ */ new Map());
    a(this, "_counters", /* @__PURE__ */ new Map());
    a(this, "_histograms", /* @__PURE__ */ new Map());
    a(this, "_up_down_counters", /* @__PURE__ */ new Map());
    a(this, "_integrations", []);
    var i, o, r, c, d;
    e.sessionSecureID || (e.sessionSecureID = A()), this.options = e, typeof ((i = this.options) == null ? void 0 : i.debug) == "boolean" ? this.debugOptions = this.options.debug ? { clientInteractions: !0 } : {} : this.debugOptions = (r = (o = this.options) == null ? void 0 : o.debug) != null ? r : {}, this.logger = new Tt(this.debugOptions.clientInteractions), e.storageMode && (this.logger.log(
      `initializing in ${e.storageMode} session mode`
    ), ct(e.storageMode)), Ee(!!(e != null && e.sessionCookie)), this._worker = new Fe(), this._worker.onmessage = (l) => {
      var h, u, m;
      ((h = l.data.response) == null ? void 0 : h.type) === C.AsyncEvents ? (this._eventBytesSinceSnapshot += l.data.response.eventsSize, this.logger.log(
        `Web worker sent payloadID ${l.data.response.id} size ${l.data.response.eventsSize} bytes, compression ratio ${l.data.response.eventsSize / l.data.response.compressedSize}.
                Total since snapshot: ${(this._eventBytesSinceSnapshot / 1e6).toFixed(1)}MB`
      )) : ((u = l.data.response) == null ? void 0 : u.type) === C.CustomEvent ? this.addCustomEvent(
        l.data.response.tag,
        l.data.response.payload
      ) : ((m = l.data.response) == null ? void 0 : m.type) === C.Stop && (U(
        "Stopping recording due to worker failure",
        l.data.response
      ), this.stopRecording(!1));
    };
    let s = M();
    if (this.reloaded = !1, !((c = this.sessionData) != null && c.sessionSecureID) && (s != null && s.sessionSecureID))
      this.sessionData = s, this.options.sessionSecureID = s.sessionSecureID, this.reloaded = !0, this.logger.log(
        `Tab reloaded, continuing previous session: ${this.sessionData.sessionSecureID}`
      );
    else {
      for (const l of Object.values(L))
        we(l);
      this.sessionData = {
        sessionSecureID: this.options.sessionSecureID,
        projectID: 0,
        payloadID: 1,
        sessionStartTime: Date.now()
      };
    }
    this._hasPreviouslyInitialized = !1, this._firstLoadListeners = t || new I(this.options);
    try {
      window.parent.document && (this._isCrossOriginIframe = !1);
    } catch (l) {
      this._isCrossOriginIframe = (d = this.options.recordCrossOriginIframe) != null ? d : !0;
    }
    this._initMembers(this.options);
  }
  static create(e) {
    return new Z(e);
  }
  // Start a new session
  _reset(t) {
    return R(this, arguments, function* ({ forceNew: e }) {
      this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      let s, i;
      if (!e)
        try {
          s = G(L.USER_IDENTIFIER);
          const o = G(
            L.USER_OBJECT
          );
          o && (i = JSON.parse(o));
        } catch (o) {
        }
      for (const o of Object.values(L))
        we(o);
      this.sessionData.sessionSecureID = A(), this.sessionData.sessionStartTime = Date.now(), this.options.sessionSecureID = this.sessionData.sessionSecureID, this.stopRecording(), this._firstLoadListeners = new I(this.options), yield this.initialize(), s && i && this.identify(s, i);
    });
  }
  _initMembers(e) {
    var o, r, c, d, l, h, u, m, f, D;
    this.sessionShortcut = !1, this._recordingStartTime = 0, this._isOnLocalHost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "", this.ready = !1, this.state = "NotRecording", this.manualStopped = !1, this.enableSegmentIntegration = !!e.enableSegmentIntegration, this.privacySetting = (o = e.privacySetting) != null ? o : "default", this.enableCanvasRecording = (r = e.enableCanvasRecording) != null ? r : !1, this.enablePerformanceRecording = (c = e.enablePerformanceRecording) != null ? c : !0, this.inlineImages = (d = e.inlineImages) != null ? d : this._isOnLocalHost, this.inlineVideos = (l = e.inlineVideos) != null ? l : this._isOnLocalHost, this.inlineStylesheet = (h = e.inlineStylesheet) != null ? h : this._isOnLocalHost, this.samplingStrategy = w({
      canvasFactor: 0.5,
      canvasMaxSnapshotDimension: 360,
      canvasClearWebGLBuffer: !0,
      dataUrlOptions: tt()
    }, (u = e.samplingStrategy) != null ? u : {
      canvas: 2
    }), this._backendUrl = (m = e == null ? void 0 : e.backendUrl) != null ? m : "https://pub.highlight.io", this._backendUrl[0] === "/" && (this._backendUrl = new URL(this._backendUrl, document.baseURI).href);
    const t = new dt(`${this._backendUrl}`, {
      headers: {}
    });
    this.graphqlSDK = st(t, lt()), this.environment = (f = e.environment) != null ? f : "production", this.appVersion = e.appVersion, this.serviceName = (D = e.serviceName) != null ? D : "", typeof e.organizationID == "string" ? this.organizationID = e.organizationID : this.organizationID = e.organizationID.toString(), this.isRunningOnHighlight = this.organizationID === "1" || this.organizationID === "1jdkoe52", this.firstloadVersion = e.firstloadVersion || "unknown", this.sessionShortcut = e.sessionShortcut || !1, this._onToggleFeedbackFormVisibility = () => {
    };
    const k = e, { firstloadVersion: s } = k, i = K(k, ["firstloadVersion"]);
    this._optionsInternal = i, this.listeners = [], this.events = [], this.hasSessionUnloaded = !1, this.hasPushedData = !1, window.Intercom && window.Intercom("onShow", () => {
      window.Intercom("update", {
        highlightSessionURL: this.getCurrentSessionURLWithTimestamp()
      }), this.addProperties({ event: "Intercom onShow" });
    }), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime(), this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime();
  }
  identify(e, t = {}, s) {
    if (!e || e === "") {
      console.warn(
        "Highlight's identify() call was passed an empty identifier.",
        { user_identifier: e, user_object: t }
      );
      return;
    }
    this.sessionData.userIdentifier = e.toString(), this.sessionData.userObject = t, J(
      L.USER_IDENTIFIER,
      e.toString()
    ), J(L.USER_OBJECT, JSON.stringify(t)), this._worker.postMessage({
      message: {
        type: C.Identify,
        userIdentifier: e,
        userObject: t,
        source: s
      }
    });
    for (const i of this._integrations)
      i.identify(
        this.sessionData.sessionSecureID,
        e,
        t,
        s
      );
  }
  log(e, t, s) {
    this._firstLoadListeners.messages.push(
      vt(t, Ne, e, s)
    );
  }
  pushCustomError(e, t) {
    return this.consumeCustomError(new Error(e), void 0, t);
  }
  consumeCustomError(e, t, s) {
    let i = {};
    if (s)
      try {
        i = w(w({}, JSON.parse(s)), i);
      } catch (o) {
      }
    return this.consumeError(e, {
      message: t,
      payload: i
    });
  }
  consumeError(e, {
    message: t,
    payload: s,
    source: i,
    type: o
  }) {
    var l, h, u, m;
    e.cause && (s = y(w({}, s), { "exception.cause": e.cause }));
    let r = t ? t + ":" + e.message : e.message;
    o === "React.ErrorBoundary" && (r = "ErrorBoundary: " + r);
    const c = Rt(e), d = {
      event: r,
      type: o != null ? o : "custom",
      url: window.location.href,
      source: i != null ? i : "",
      lineNumber: (l = c[0]) != null && l.lineNumber ? (h = c[0]) == null ? void 0 : h.lineNumber : 0,
      columnNumber: (u = c[0]) != null && u.columnNumber ? (m = c[0]) == null ? void 0 : m.columnNumber : 0,
      stackTrace: c,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      payload: JSON.stringify(s)
    };
    this._firstLoadListeners.errors.push(d);
    for (const f of this._integrations)
      f.error(this.sessionData.sessionSecureID, d);
  }
  addProperties(e = {}, t) {
    const s = w({}, e);
    Object.entries(s).forEach(([i, o]) => {
      try {
        structuredClone(o);
      } catch (r) {
        delete s[i];
      }
    }), this._worker.postMessage({
      message: {
        type: C.Properties,
        propertiesObject: s,
        propertyType: t
      }
    });
    for (const i of this._integrations)
      i.track(this.sessionData.sessionSecureID, w({
        sessionSecureID: this.sessionData.sessionSecureID,
        propertyType: t
      }, e));
  }
  initialize(e) {
    return R(this, null, function* () {
      var t, s, i, o, r, c, d, l, h, u, m, f, D, k, N, S, ee, te, se, ie, ne, re, oe, ae, ce;
      if (navigator != null && navigator.webdriver && !window.Cypress || (t = navigator == null ? void 0 : navigator.userAgent) != null && t.includes("Googlebot") || (s = navigator == null ? void 0 : navigator.userAgent) != null && s.includes("AdsBot")) {
        (i = this._firstLoadListeners) == null || i.stopListening();
        return;
      }
      try {
        if (e != null && e.forceNew) {
          yield this._reset(e);
          return;
        }
        const O = new _t();
        Dt(
          {
            backendUrl: (r = (o = this.options) == null ? void 0 : o.backendUrl) != null ? r : "https://pub.highlight.io",
            otlpEndpoint: (d = (c = this.options) == null ? void 0 : c.otlpEndpoint) != null ? d : "https://otel.highlight.io",
            projectId: (l = this.options) == null ? void 0 : l.organizationID,
            sessionSecureId: (h = this.options) == null ? void 0 : h.sessionSecureID,
            environment: (m = (u = this.options) == null ? void 0 : u.environment) != null ? m : "production",
            networkRecordingOptions: typeof ((f = this.options) == null ? void 0 : f.networkRecording) == "object" ? this.options.networkRecording : void 0,
            tracingOrigins: (D = this.options) == null ? void 0 : D.tracingOrigins,
            serviceName: (N = (k = this.options) == null ? void 0 : k.serviceName) != null ? N : "highlight-browser",
            instrumentations: (ee = (S = this.options) == null ? void 0 : S.otel) == null ? void 0 : ee.instrumentations,
            eventNames: (se = (te = this.options) == null ? void 0 : te.otel) == null ? void 0 : se.eventNames,
            getIntegrations: () => [...this._integrations]
          },
          O
        ), this.logger.log(
          "Initializing...",
          e,
          this.sessionData,
          this.options
        ), this.sessionData = (ie = M(this.sessionData.sessionSecureID)) != null ? ie : this.sessionData, (ne = this.sessionData) != null && ne.sessionStartTime ? this._recordingStartTime = (re = this.sessionData) == null ? void 0 : re.sessionStartTime : (this._recordingStartTime = (/* @__PURE__ */ new Date()).getTime(), this.sessionData.sessionStartTime = this._recordingStartTime), Q(""), P(this.sessionData);
        let T = G(be.CLIENT_ID);
        T || (T = A(), J(be.CLIENT_ID, T));
        let H;
        this.options.disableSessionRecording || this.options.disableNetworkRecording !== void 0 || typeof this.options.networkRecording == "boolean" ? H = !1 : H = ((oe = this.options.networkRecording) == null ? void 0 : oe.recordHeadersAndBody) || !1;
        let le = [];
        if (typeof this.options.networkRecording == "object" && ((ae = this.options.networkRecording.destinationDomains) != null && ae.length) && (le = this.options.networkRecording.destinationDomains), this._isCrossOriginIframe)
          yield this._setupCrossOriginIframe();
        else {
          const v = yield this.graphqlSDK.initializeSession({
            organization_verbose_id: this.organizationID,
            enable_strict_privacy: this.privacySetting === "strict",
            privacy_setting: this.privacySetting,
            enable_recording_network_contents: H,
            clientVersion: this.firstloadVersion,
            firstloadVersion: this.firstloadVersion,
            clientConfig: JSON.stringify(this._optionsInternal),
            environment: this.environment,
            id: T,
            appVersion: this.appVersion,
            serviceName: this.serviceName,
            session_secure_id: this.sessionData.sessionSecureID,
            client_id: T,
            network_recording_domains: le,
            disable_session_recording: this.options.disableSessionRecording
          });
          if (v.initializeSession.secure_id !== this.sessionData.sessionSecureID && this.logger.log(
            `Unexpected secure id returned by initializeSession: ${v.initializeSession.secure_id}, expected ${this.sessionData.sessionSecureID}`
          ), this.sessionData.sessionSecureID = v.initializeSession.secure_id, this.sessionData.projectID = parseInt(
            ((ce = v == null ? void 0 : v.initializeSession) == null ? void 0 : ce.project_id) || "0"
          ), O.setConfig(v.initializeSession.sampling), !this.sessionData.projectID || !this.sessionData.sessionSecureID) {
            console.error(
              "Failed to initialize Highlight; an error occurred on our end.",
              this.sessionData
            );
            return;
          }
        }
        this.logger.log(
          `Loaded Highlight
Remote: ${this._backendUrl}
Project ID: ${this.sessionData.projectID}
SessionSecureID: ${this.sessionData.sessionSecureID}`
        ), this.options.sessionSecureID = this.sessionData.sessionSecureID, this._worker.postMessage({
          message: {
            type: C.Initialize,
            sessionSecureID: this.sessionData.sessionSecureID,
            backend: this._backendUrl,
            debug: !!this.debugOptions.clientInteractions,
            recordingStartTime: this._recordingStartTime
          }
        });
        for (const v of this._integrations)
          v.init(this.sessionData.sessionSecureID);
        if (this.sessionData.userIdentifier && this.identify(
          this.sessionData.userIdentifier,
          this.sessionData.userObject
        ), this._firstLoadListeners.isListening() ? this._firstLoadListeners.hasNetworkRecording || I.setupNetworkListener(
          this._firstLoadListeners,
          this.options
        ) : this._firstLoadListeners.startListening(), this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this._isCrossOriginIframe || (this.pushPayloadTimerId = setTimeout(() => {
          this._save();
        }, Se)), this.options.disableSessionRecording) {
          this.logger.log(
            "Highlight is NOT RECORDING a session replay per H.init setting."
          ), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
          return;
        }
        const { getDeviceDetails: de } = It();
        de && this.recordGauge({
          name: E.DeviceMemory,
          value: de().deviceMemory,
          category: _.Device,
          group: window.location.href
        });
        const he = (v, We) => {
          We && this.logger.log("received isCheckout emit", { event: v }), this.events.push(v);
        };
        he.bind(this);
        const He = !!this._recordStop;
        this._recordStop && (this._recordStop(), this._recordStop = void 0);
        const [Pe, Ue] = Qe(
          this.privacySetting
        );
        this._recordStop = j({
          ignoreClass: "highlight-ignore",
          blockClass: "highlight-block",
          emit: he,
          recordCrossOriginIframes: this.options.recordCrossOriginIframe,
          privacySetting: this.privacySetting,
          maskAllInputs: Pe,
          maskInputOptions: Ue,
          recordCanvas: this.enableCanvasRecording,
          sampling: {
            canvas: {
              fps: this.samplingStrategy.canvas,
              fpsManual: this.samplingStrategy.canvasManualSnapshot,
              resizeFactor: this.samplingStrategy.canvasFactor,
              clearWebGLBuffer: this.samplingStrategy.canvasClearWebGLBuffer,
              initialSnapshotDelay: this.samplingStrategy.canvasInitialSnapshotDelay,
              dataURLOptions: this.samplingStrategy.dataUrlOptions,
              maxSnapshotDimension: this.samplingStrategy.canvasMaxSnapshotDimension
            }
          },
          keepIframeSrcFn: (v) => !this.options.recordCrossOriginIframe,
          inlineImages: this.inlineImages,
          inlineVideos: this.inlineVideos,
          collectFonts: this.inlineImages,
          inlineStylesheet: this.inlineStylesheet,
          plugins: [Je()],
          logger: typeof this.options.debug == "boolean" && this.options.debug || typeof this.options.debug == "object" && this.options.debug.domRecording ? {
            debug: this.logger.log,
            warn: U
          } : void 0
        }), He || this.options.recordCrossOriginIframe && this._setupCrossOriginIframeParent(), document.referrer && (window && document.referrer.includes(window.location.origin) || (this.addCustomEvent("Referrer", document.referrer), this.addProperties(
          { referrer: document.referrer },
          { type: "session" }
        ))), this._setupWindowListeners(), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
      } catch (O) {
        this._isOnLocalHost && (console.error(O), U("initializeSession", O));
      }
    });
  }
  _visibilityHandler(e) {
    return R(this, null, function* () {
      if (this.manualStopped) {
        this.logger.log("Ignoring visibility event due to manual stop.");
        return;
      }
      (/* @__PURE__ */ new Date()).getTime() - this._lastVisibilityChangeTime < it || (this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime(), this.logger.log(`Detected window ${e ? "hidden" : "visible"}.`), e ? (this.addCustomEvent("TabHidden", !0), this.options.disableBackgroundRecording && this.stopRecording()) : (this.options.disableBackgroundRecording && (yield this.initialize()), this.addCustomEvent("TabHidden", !1)));
    });
  }
  _setupCrossOriginIframe() {
    return R(this, null, function* () {
      this.logger.log("highlight in cross-origin iframe is waiting "), yield new Promise((e) => {
        const t = (s) => {
          if (s.data.highlight === me) {
            const i = s.data;
            this.logger.log("highlight got window message ", i), this.sessionData.projectID = i.projectID, this.sessionData.sessionSecureID = i.sessionSecureID, window.parent.postMessage(
              {
                highlight: fe
              },
              "*"
            ), window.removeEventListener("message", t), e();
          }
        };
        window.addEventListener("message", t);
      });
    });
  }
  _setupCrossOriginIframeParent() {
    this.logger.log(
      "highlight setting up cross origin iframe parent notification"
    ), setInterval(() => {
      window.document.querySelectorAll("iframe").forEach((e) => {
        var t;
        (t = e.contentWindow) == null || t.postMessage(
          {
            highlight: me,
            projectID: this.sessionData.projectID,
            sessionSecureID: this.sessionData.sessionSecureID
          },
          "*"
        );
      });
    }, Se), window.addEventListener("message", (e) => {
      e.data.highlight === fe && this.logger.log(
        "highlight got response from initialized iframe"
      );
    });
  }
  _setupWindowListeners() {
    var s;
    try {
      const i = this;
      this.enableSegmentIntegration && this.listeners.push(
        Ve((r) => {
          if (r.type === "track") {
            const c = {};
            c["segment-event"] = r.event, i.addProperties(c, {
              type: "track",
              source: "segment"
            });
          } else if (r.type === "identify") {
            const c = r.userId.replace(
              /^"(.*)"$/,
              "$1"
            );
            i.identify(
              c,
              r.traits,
              "segment"
            );
          }
        })
      ), this.listeners.push(
        $e((r) => {
          this.reloaded ? (this.addCustomEvent("Reload", r), this.reloaded = !1, i.addProperties(
            { reload: !0 },
            { type: "session" }
          )) : this.addCustomEvent("Navigate", r);
        })
      ), this.listeners.push(
        nt(
          (r) => {
            this.addCustomEvent("Viewport", r), this.submitViewportMetrics(r);
          }
        )
      ), this.listeners.push(
        Ae((r, c) => {
          let d = null, l = null;
          if (c && c.target) {
            const h = c.target;
            d = ht(h), l = h.textContent, l && l.length > 2e3 && (l = l.substring(0, 2e3));
          }
          this.addCustomEvent("Click", {
            clickTarget: r,
            clickTextContent: l,
            clickSelector: d
          });
        })
      ), this.listeners.push(
        xe((r) => {
          r && this.addCustomEvent("Focus", r);
        })
      ), this.listeners.push(
        Ct((r) => {
          const { name: c, value: d } = r;
          this.recordGauge({
            name: c,
            value: d,
            group: window.location.href,
            category: _.WebVital
          });
        })
      ), this.listeners.push(
        Lt(
          (r) => {
            const c = [];
            r.saveData !== void 0 && c.push({
              name: "saveData",
              value: r.saveData.toString()
            }), r.effectiveType !== void 0 && c.push({
              name: "effectiveType",
              value: r.effectiveType.toString()
            }), r.type !== void 0 && c.push({
              name: "type",
              value: r.type.toString()
            }), Object.entries(r).forEach(
              ([d, l]) => l && typeof l == "number" && this.recordGauge({
                name: d,
                value: l,
                category: _.Performance,
                group: window.location.href,
                tags: c
              })
            );
          },
          this._recordingStartTime
        )
      ), this.sessionShortcut && qe(this.sessionShortcut, () => {
        window.open(
          this.getCurrentSessionURLWithTimestamp(),
          "_blank"
        );
      }), this.enablePerformanceRecording && (this.listeners.push(
        Et((r) => {
          this.addCustomEvent("Performance", $(r)), Object.entries(r).filter(([c]) => c !== "relativeTimestamp").forEach(
            ([c, d]) => d && this.recordGauge({
              name: c,
              value: d,
              category: _.Performance,
              group: window.location.href
            })
          );
        }, this._recordingStartTime)
      ), this.listeners.push(
        Nt((r) => {
          this.addCustomEvent("Jank", $(r)), this.recordGauge({
            name: "Jank",
            value: r.jankAmount,
            category: _.WebVital,
            group: r.querySelector
          });
        }, this._recordingStartTime)
      )), this._hasPreviouslyInitialized || ((s = window.electron) != null && s.ipcRenderer ? (window.electron.ipcRenderer.on(
        "highlight.run",
        ({ visible: r }) => {
          this._visibilityHandler(!r);
        }
      ), this.logger.log("Set up Electron highlight.run events.")) : (Ke(
        (r) => this._visibilityHandler(r)
      ), this.logger.log("Set up document visibility listener.")), this._hasPreviouslyInitialized = !0);
      const o = () => {
        this.hasSessionUnloaded = !0, this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      };
      window.addEventListener("beforeunload", o), this.listeners.push(
        () => window.removeEventListener("beforeunload", o)
      );
    } catch (i) {
      this._isOnLocalHost && (console.error(i), U("initializeSession _setupWindowListeners", i));
    }
    const e = () => {
      this.addCustomEvent("Page Unload", ""), Q(this.sessionData.sessionSecureID), P(this.sessionData);
    };
    if (window.addEventListener("beforeunload", e), this.listeners.push(
      () => window.removeEventListener("beforeunload", e)
    ), navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
      const i = () => {
        this.addCustomEvent("Page Unload", ""), Q(this.sessionData.sessionSecureID), P(this.sessionData);
      };
      window.addEventListener("pagehide", i), this.listeners.push(
        () => window.removeEventListener("beforeunload", i)
      );
    }
  }
  submitViewportMetrics({
    height: e,
    width: t,
    availHeight: s,
    availWidth: i
  }) {
    this.recordGauge({
      name: E.ViewportHeight,
      value: e,
      category: _.Device,
      group: window.location.href
    }), this.recordGauge({
      name: E.ViewportWidth,
      value: t,
      category: _.Device,
      group: window.location.href
    }), this.recordGauge({
      name: E.ScreenHeight,
      value: s,
      category: _.Device,
      group: window.location.href
    }), this.recordGauge({
      name: E.ScreenWidth,
      value: i,
      category: _.Device,
      group: window.location.href
    }), this.recordGauge({
      name: E.ViewportArea,
      value: e * t,
      category: _.Device,
      group: window.location.href
    });
  }
  recordGauge(e) {
    var i;
    const t = F.getMeter(V);
    let s = this._gauges.get(e.name);
    s || (s = t.createGauge(e.name), this._gauges.set(e.name, s)), s.record(e.value, y(w({}, (i = e.tags) == null ? void 0 : i.reduce((o, r) => y(w({}, o), { [r.name]: r.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
    for (const o of this._integrations)
      o.recordGauge(this.sessionData.sessionSecureID, e);
  }
  recordCount(e) {
    var i;
    const t = F.getMeter(V);
    let s = this._counters.get(e.name);
    s || (s = t.createCounter(e.name), this._counters.set(e.name, s)), s.add(e.value, y(w({}, (i = e.tags) == null ? void 0 : i.reduce((o, r) => y(w({}, o), { [r.name]: r.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
  }
  recordIncr(e) {
    this.recordCount(y(w({}, e), { value: 1 }));
  }
  recordHistogram(e) {
    var i;
    const t = F.getMeter(V);
    let s = this._histograms.get(e.name);
    s || (s = t.createHistogram(e.name), this._histograms.set(e.name, s)), s.record(e.value, y(w({}, (i = e.tags) == null ? void 0 : i.reduce((o, r) => y(w({}, o), { [r.name]: r.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
  }
  recordUpDownCounter(e) {
    var i;
    const t = F.getMeter(V);
    let s = this._up_down_counters.get(e.name);
    s || (s = t.createUpDownCounter(e.name), this._up_down_counters.set(e.name, s)), s.add(e.value, y(w({}, (i = e.tags) == null ? void 0 : i.reduce((o, r) => y(w({}, o), { [r.name]: r.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
  }
  /**
   * Stops Highlight from recording.
   * @param manual The end user requested to stop recording.
   */
  stopRecording(e) {
    this.manualStopped = !!e, this.manualStopped && this.addCustomEvent(
      "Stop",
      "H.stop() was called which stops Highlight from recording."
    ), this.state = "NotRecording", e && this._recordStop && (this._recordStop(), this._recordStop = void 0), this.listeners.forEach((t) => t()), this.listeners = [];
  }
  getCurrentSessionTimestamp() {
    return this._recordingStartTime;
  }
  /**
   * Returns the current timestamp for the current session.
   */
  getCurrentSessionURLWithTimestamp() {
    const e = (/* @__PURE__ */ new Date()).getTime(), { projectID: t, sessionSecureID: s } = this.sessionData, i = (e - this._recordingStartTime) / 1e3;
    return `https://${Y}/${t}/sessions/${s}?ts=${i}`;
  }
  getCurrentSessionURL() {
    const e = this.sessionData.projectID, t = this.sessionData.sessionSecureID;
    return e && t ? `https://${Y}/${e}/sessions/${t}` : null;
  }
  snapshot(e) {
    return R(this, null, function* () {
      yield j.snapshotCanvas(e);
    });
  }
  addSessionFeedback({
    timestamp: e,
    verbatim: t,
    user_email: s,
    user_name: i
  }) {
    var o;
    this._worker.postMessage({
      message: {
        type: C.Feedback,
        verbatim: t,
        timestamp: e,
        userName: i || this.sessionData.userIdentifier,
        userEmail: s || ((o = this.sessionData.userObject) == null ? void 0 : o.name)
      }
    });
  }
  // Reset the events array and push to a backend.
  _save() {
    return R(this, null, function* () {
      var e;
      try {
        this.state === "Recording" && this.listeners && this.sessionData.sessionStartTime && Date.now() - this.sessionData.sessionStartTime > rt && (this.logger.log("Resetting session", {
          start: this.sessionData.sessionStartTime
        }), yield this._reset({}));
        let t;
        ((e = this.options) == null ? void 0 : e.sendMode) === "local" && (t = (s) => R(this, null, function* () {
          let i = new Blob(
            [
              JSON.stringify({
                query: at(gt),
                variables: s
              })
            ],
            {
              type: "application/json"
            }
          );
          return yield window.fetch(`${this._backendUrl}`, {
            method: "POST",
            body: i
          }), 0;
        })), yield this._sendPayload({ sendFn: t }), this.hasPushedData = !0, this.sessionData.lastPushTime = Date.now(), P(this.sessionData);
      } catch (t) {
        this._isOnLocalHost && (console.error(t), U("_save", t));
      }
      this.state === "Recording" && (this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this.pushPayloadTimerId = setTimeout(() => {
        this._save();
      }, ot));
    });
  }
  /**
   * This proxy should be used instead of rrweb's native addCustomEvent.
   * The proxy makes sure recording has started before emitting a custom event.
   */
  addCustomEvent(e, t) {
    if (this.state === "NotRecording") {
      let s;
      const i = () => {
        clearInterval(s), this.state === "Recording" && this.events.length > 0 ? pe(e, t) : s = setTimeout(i, 500);
      };
      s = setTimeout(i, 500);
    } else this.state === "Recording" && (this.events.length > 0 || this.hasPushedData) && pe(e, t);
  }
  _sendPayload(t) {
    return R(this, arguments, function* ({
      sendFn: e
    }) {
      const s = I.getRecordedNetworkResources(
        this._firstLoadListeners,
        this._recordingStartTime
      ), i = I.getRecordedWebSocketEvents(
        this._firstLoadListeners
      ), o = [...this.events], r = [...this._firstLoadListeners.messages], c = [...this._firstLoadListeners.errors], { bytes: d, time: l } = this.enableCanvasRecording ? ye.canvas : ye.normal;
      this._eventBytesSinceSnapshot >= d && (/* @__PURE__ */ new Date()).getTime() - this._lastSnapshotTime >= l && this.takeFullSnapshot(), this.logger.log(
        `Sending: ${o.length} events, ${r.length} messages, ${s.length} network resources, ${c.length} errors 
To: ${this._backendUrl}
Org: ${this.organizationID}
SessionSecureID: ${this.sessionData.sessionSecureID}`
      );
      const h = je();
      e ? yield e({
        session_secure_id: this.sessionData.sessionSecureID,
        payload_id: (this.sessionData.payloadID++).toString(),
        events: { events: o },
        messages: $({ messages: r }),
        resources: JSON.stringify({ resources: s }),
        web_socket_events: JSON.stringify({
          webSocketEvents: i
        }),
        errors: c,
        is_beacon: !1,
        has_session_unloaded: this.hasSessionUnloaded,
        highlight_logs: h || void 0
      }) : this._worker.postMessage({
        message: {
          type: C.AsyncEvents,
          id: this.sessionData.payloadID++,
          events: o,
          messages: r,
          errors: c,
          resourcesString: JSON.stringify({ resources: s }),
          webSocketEventsString: JSON.stringify({
            webSocketEvents: i
          }),
          hasSessionUnloaded: this.hasSessionUnloaded,
          highlightLogs: h
        }
      }), P(this.sessionData), I.clearRecordedNetworkResources(
        this._firstLoadListeners
      ), this.events = this.events.slice(o.length), this._firstLoadListeners.messages = this._firstLoadListeners.messages.slice(r.length), this._firstLoadListeners.errors = this._firstLoadListeners.errors.slice(
        c.length
      ), Ge(h);
    });
  }
  takeFullSnapshot() {
    if (!this._recordStop) {
      this.logger.log("skipping full snapshot as rrweb is not running");
      return;
    }
    this.logger.log("taking full snapshot", {
      bytesSinceSnapshot: this._eventBytesSinceSnapshot,
      lastSnapshotTime: this._lastSnapshotTime
    }), j.takeFullSnapshot(), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime();
  }
  registerLD(e) {
    this._integrations.length || this._integrations.push(new Le(e));
  }
}
const Ut = () => {
  var n, e;
  typeof chrome != "undefined" && ((n = chrome == null ? void 0 : chrome.runtime) != null && n.onMessage) && ((e = chrome == null ? void 0 : chrome.runtime) == null || e.onMessage.addListener(
    (t, s, i) => {
      const o = t.action;
      switch (console.log(
        `[highlight] received '${o}' event from extension.`
      ), o) {
        case "init": {
          p.init(1, {
            debug: !0
          }), p.getSessionURL().then((r) => {
            i({ url: r });
          });
          break;
        }
        case "stop": {
          p.stop(), i({ success: !0 });
          break;
        }
      }
      return !0;
    }
  ));
};
function At(n) {
  var e;
  n.on && ((e = n.webContents) != null && e.send) && (n.on("focus", () => {
    n.webContents.send("highlight.run", { visible: !0 });
  }), n.on("blur", () => {
    n.webContents.send("highlight.run", { visible: !1 });
  }), n.on("close", () => {
    n.webContents.send("highlight.run", { visible: !1 });
  }));
}
const xt = ({
  next: n,
  payload: e
}) => {
  if (typeof window != "undefined" && typeof document != "undefined" && "H" in window) {
    if (e.obj.type === "track") {
      const t = e.obj.event, s = e.obj.properties;
      window.H.track(t, s);
    } else if (e.obj.type === "identify") {
      const t = e.obj.userId;
      if (t != null && t.length) {
        const s = e.obj.traits;
        window.H.identify(t, s);
      }
    }
  }
  n(e);
}, Oe = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightFetchPatch != "undefined")
      return;
    window._originalFetch = window.fetch, window._fetchProxy = (n, e) => window._originalFetch(n, e), window._highlightFetchPatch = (n, e) => window._fetchProxy.call(window || global, n, e), window.fetch = window._highlightFetchPatch;
  }
}, Ie = () => null, Te = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightWebSocketRequestCallback != "undefined")
      return;
    window._highlightWebSocketRequestCallback = Ie, window._highlightWebSocketEventCallback = Ie;
    const n = new Proxy(window.WebSocket, {
      construct(e, t) {
        const [, s] = Ot(), i = new e(...t), o = (h) => {
          window._highlightWebSocketRequestCallback({
            socketId: s,
            initiatorType: "websocket",
            type: "open",
            name: i.url,
            startTimeAbs: performance.timeOrigin + h.timeStamp
          });
        }, r = (h) => {
          window._highlightWebSocketRequestCallback({
            socketId: s,
            initiatorType: "websocket",
            type: "close",
            name: i.url,
            responseEndAbs: performance.timeOrigin + h.timeStamp
          }), i.removeEventListener("open", o), i.removeEventListener("error", d), i.removeEventListener("message", c), i.removeEventListener("close", r);
        }, c = (h) => {
          const { data: u } = h, m = typeof u == "string" ? h.data : void 0;
          let f;
          typeof u == "string" ? f = u.length : u instanceof Blob ? f = u.size : f = u.byteLength || 0, window._highlightWebSocketEventCallback({
            socketId: s,
            type: "received",
            name: i.url,
            timeStamp: performance.timeOrigin + h.timeStamp,
            size: f,
            message: m
          });
        }, d = (h) => {
          window._highlightWebSocketEventCallback({
            socketId: s,
            type: "error",
            name: i.url,
            timeStamp: performance.timeOrigin + h.timeStamp,
            size: 0
          });
        };
        i.addEventListener("open", o), i.addEventListener("error", d), i.addEventListener("message", c), i.addEventListener("close", r);
        const l = new Proxy(i.send, {
          apply: function(h, u, m) {
            const f = m[0], D = typeof f == "string" ? f : void 0;
            let k;
            typeof f == "string" ? k = f.length : f instanceof Blob ? k = f.size : k = f.byteLength || 0, window._highlightWebSocketEventCallback({
              socketId: s,
              type: "sent",
              name: i.url,
              timeStamp: performance.timeOrigin + performance.now(),
              size: k,
              message: D
            }), h.apply(u, m);
          }
        });
        return i.send = l, i;
      }
    });
    window.WebSocket = n;
  }
};
var Wt = /* @__PURE__ */ ((n) => (n.Device = "Device", n.WebVital = "WebVital", n.Frontend = "Frontend", n.Backend = "Backend", n))(Wt || {});
const b = (n, e) => {
  console.warn(`highlight.run warning: (${n}): `, e);
}, zt = 200;
let W = [], x, g, z, Ce = [], X = !1;
const p = {
  options: void 0,
  init: (n, e) => {
    var t, s, i, o, r, c, d, l;
    try {
      if (p.options = e, typeof window == "undefined" || typeof document == "undefined")
        return;
      if (!n) {
        console.info(
          "Highlight is not initializing because projectID was passed undefined."
        );
        return;
      }
      e != null && e.sessionCookie ? mt() : Ee(!1);
      let h = M(), u = A();
      if (h != null && h.sessionSecureID && (u = h.sessionSecureID), X)
        return { sessionSecureID: u };
      X = !0, Oe(), Te();
      const m = y(w({}, e), {
        organizationID: n,
        firstloadVersion: Ye,
        environment: (e == null ? void 0 : e.environment) || "production",
        appVersion: e == null ? void 0 : e.version,
        sessionSecureID: u
      });
      return g = g != null ? g : new Z(m, z), e != null && e.manualStart || g.initialize(), z = new I(m), e != null && e.manualStart || z.startListening(), !((s = (t = e == null ? void 0 : e.integrations) == null ? void 0 : t.mixpanel) != null && s.disabled) && ((o = (i = e == null ? void 0 : e.integrations) == null ? void 0 : i.mixpanel) != null && o.projectToken) && Xe(e.integrations.mixpanel), !((c = (r = e == null ? void 0 : e.integrations) == null ? void 0 : r.amplitude) != null && c.disabled) && ((l = (d = e == null ? void 0 : e.integrations) == null ? void 0 : d.amplitude) != null && l.apiKey) && Ze(e.integrations.amplitude), { sessionSecureID: u };
    } catch (h) {
      b("init", h);
    }
  },
  snapshot: (n) => R(void 0, null, function* () {
    try {
      if (g && g.ready)
        return yield g.snapshot(n);
    } catch (e) {
      b("snapshot", e);
    }
  }),
  addSessionFeedback: ({
    verbatim: n,
    userName: e,
    userEmail: t,
    timestampOverride: s
  }) => {
    try {
      p.onHighlightReady(
        () => g.addSessionFeedback({
          verbatim: n,
          timestamp: s || (/* @__PURE__ */ new Date()).toISOString(),
          user_email: t,
          user_name: e
        })
      );
    } catch (i) {
      b("error", i);
    }
  },
  consumeError: (n, e, t) => {
    try {
      p.onHighlightReady(
        () => g.consumeCustomError(
          n,
          e,
          JSON.stringify(t)
        )
      );
    } catch (s) {
      b("error", s);
    }
  },
  consume: (n, e) => {
    try {
      p.onHighlightReady(() => g.consumeError(n, e));
    } catch (t) {
      b("error", t);
    }
  },
  error: (n, e) => {
    try {
      p.onHighlightReady(
        () => g.pushCustomError(n, JSON.stringify(e))
      );
    } catch (t) {
      b("error", t);
    }
  },
  track: (n, e = {}) => {
    var t, s, i, o, r, c, d, l, h, u, m;
    try {
      p.onHighlightReady(() => {
        g.addProperties(y(w({}, e), { event: n })), g.log("H.track", "INFO", y(w({}, e != null ? e : {}), {
          event: n
        }));
      });
      const f = g == null ? void 0 : g.getCurrentSessionURL();
      (i = (s = (t = p.options) == null ? void 0 : t.integrations) == null ? void 0 : s.mixpanel) != null && i.disabled || (o = window.mixpanel) != null && o.track && window.mixpanel.track(n, y(w({}, e), {
        highlightSessionURL: f
      })), (d = (c = (r = p.options) == null ? void 0 : r.integrations) == null ? void 0 : c.amplitude) != null && d.disabled || (l = window.amplitude) != null && l.getInstance && window.amplitude.getInstance().logEvent(n, y(w({}, e), {
        highlightSessionURL: f
      })), (m = (u = (h = p.options) == null ? void 0 : h.integrations) == null ? void 0 : u.intercom) != null && m.disabled || window.Intercom && window.Intercom("trackEvent", n, e);
    } catch (f) {
      b("track", f);
    }
  },
  log: (n, e, t) => {
    try {
      p.onHighlightReady(
        () => g.log(n, e, t != null ? t : {})
      );
    } catch (s) {
      b("log", s);
    }
  },
  start: (n) => {
    (g == null ? void 0 : g.state) === "Recording" && !(n != null && n.forceNew) ? n != null && n.silent || console.warn(
      "Highlight is already recording. Please `H.stop()` the current session before starting a new one."
    ) : (z.startListening(), p.onHighlightReady(
      () => R(void 0, null, function* () {
        yield g.initialize(n);
      }),
      { waitForReady: !1 }
    ));
  },
  stop: (n) => {
    (g == null ? void 0 : g.state) !== "Recording" ? n != null && n.silent || console.warn(
      "Highlight is already stopped. Please call `H.start()`."
    ) : p.onHighlightReady(() => g.stopRecording(!0));
  },
  identify: (n, e = {}, t) => {
    var s, i, o, r, c, d, l, h;
    try {
      p.onHighlightReady(
        () => g.identify(n, e, t)
      );
    } catch (u) {
      b("identify", u);
    }
    if ((o = (i = (s = p.options) == null ? void 0 : s.integrations) == null ? void 0 : i.mixpanel) != null && o.disabled || (r = window.mixpanel) != null && r.identify && (window.mixpanel.identify(
      typeof (e == null ? void 0 : e.email) == "string" ? e == null ? void 0 : e.email : n
    ), e && (window.mixpanel.track("identify", e), window.mixpanel.people.set(e))), !((l = (d = (c = p.options) == null ? void 0 : c.integrations) == null ? void 0 : d.amplitude) != null && l.disabled) && (h = window.amplitude) != null && h.getInstance && (window.amplitude.getInstance().setUserId(n), Object.keys(e).length > 0)) {
      const u = Object.keys(
        e
      ).reduce((m, f) => (m.set(f, e[f]), m), new window.amplitude.Identify());
      window.amplitude.getInstance().identify(u);
    }
  },
  metrics: (n) => {
    try {
      for (const e of n)
        p.recordMetric(e);
    } catch (e) {
      b("metrics", e);
    }
  },
  recordMetric: (n) => {
    try {
      p.onHighlightReady(() => {
        var e;
        g.recordGauge(y(w({}, n), {
          tags: (e = n.tags) != null ? e : [],
          group: window.location.href,
          category: "Frontend"
          /* Frontend */
        }));
      });
    } catch (e) {
      b("recordMetric", e);
    }
  },
  recordCount: (n) => {
    try {
      p.onHighlightReady(() => {
        g.recordCount(n);
      });
    } catch (e) {
      b("recordCount", e);
    }
  },
  recordIncr: (n) => {
    try {
      p.onHighlightReady(() => {
        g.recordIncr(n);
      });
    } catch (e) {
      b("recordIncr", e);
    }
  },
  recordHistogram: (n) => {
    try {
      p.onHighlightReady(() => {
        g.recordHistogram(n);
      });
    } catch (e) {
      b("recordHistogram", e);
    }
  },
  recordUpDownCounter: (n) => {
    try {
      p.onHighlightReady(() => {
        g.recordUpDownCounter(n);
      });
    } catch (e) {
      b("recordUpDownCounter", e);
    }
  },
  startSpan: (n, e, t, s) => {
    const i = De();
    if (!i) {
      const r = _e();
      return s === void 0 && t === void 0 ? e(r) : s === void 0 ? t(r) : s(r);
    }
    const o = (r, c) => {
      const d = c(r);
      return d instanceof Promise ? d.finally(() => r.end()) : (r.end(), d);
    };
    return s === void 0 && t === void 0 ? i.startActiveSpan(
      n,
      (r) => o(r, e)
    ) : s === void 0 ? i.startActiveSpan(
      n,
      e,
      (r) => o(r, t)
    ) : i.startActiveSpan(
      n,
      e,
      t,
      (r) => o(r, s)
    );
  },
  startManualSpan: (n, e, t, s) => {
    const i = De();
    if (!i) {
      const o = _e();
      return s === void 0 && t === void 0 ? e(o) : s === void 0 ? t(o) : s(o);
    }
    return s === void 0 && t === void 0 ? i.startActiveSpan(n, e) : s === void 0 ? i.startActiveSpan(
      n,
      e,
      t
    ) : i.startActiveSpan(
      n,
      e,
      t,
      s
    );
  },
  getSessionURL: () => new Promise((n, e) => {
    p.onHighlightReady(() => {
      const t = g.sessionData.sessionSecureID, s = M(t);
      s ? n(
        `https://${Y}/${s.projectID}/sessions/${t}`
      ) : e(new Error(`Unable to get session URL: ${t}`));
    });
  }),
  getSessionDetails: () => new Promise((n, e) => {
    p.onHighlightReady(() => R(void 0, null, function* () {
      try {
        const t = yield p.getSessionURL();
        if (!t)
          throw new Error("Could not get session URL");
        const s = g.sessionData.sessionSecureID, i = M(s), o = i == null ? void 0 : i.sessionStartTime;
        if (!o)
          throw new Error("Could not get session start timestamp");
        const r = (/* @__PURE__ */ new Date()).getTime(), c = new URL(t), d = new URL(t);
        d.searchParams.set(
          "ts",
          ((r - o) / 1e3).toString()
        ), n({
          url: c.toString(),
          urlWithTimestamp: d.toString(),
          sessionSecureID: s
        });
      } catch (t) {
        e(t);
      }
    }));
  }),
  getRecordingState: () => {
    var n;
    return (n = g == null ? void 0 : g.state) != null ? n : "NotRecording";
  },
  onHighlightReady: (n, e) => {
    if (g && g.ready) {
      n();
      return;
    }
    if (W.push({ options: e, func: n }), x !== void 0)
      return;
    const t = () => {
      W = W.filter((i) => {
        var o;
        return !g || ((o = i.options) == null ? void 0 : o.waitForReady) !== !1 && !g.ready ? !0 : (i.func(), !1);
      }), x = void 0, W.length > 0 && (x = setTimeout(
        t,
        zt
      ));
    };
    t();
  },
  registerLD(n) {
    Ce.length || (p.onHighlightReady(() => {
      g.registerLD(n);
    }), ut(this, n), Ce.push(new Le(n)));
  }
};
typeof window != "undefined" && (window.H = p);
Ut();
Oe();
Te();
const qt = {
  reset: () => {
    X = !1, g = void 0, W = [], x = void 0, z = void 0;
  },
  setHighlightObj: (n) => {
    g = n;
  }
};
export {
  A as GenerateSecureID,
  p as H,
  xt as HighlightSegmentMiddleware,
  Xt as LDObserve,
  es as LDRecord,
  Wt as MetricCategory,
  Qt as Observe,
  Gt as Record,
  qt as __testing,
  At as configureElectronHighlight
};
//# sourceMappingURL=index.js.map
